var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebookMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6C2.69 0 0 2.69 0 6v12c0 3.31 2.69 6 6 6h6.82v-9.28H9.7v-3.63h3.12V8.42c0-3.1 1.89-4.79 4.66-4.79 1.32 0 2.46.1 2.79.14v3.24h-1.91c-1.5 0-1.8.72-1.8 1.77v2.31h3.6l-.47 3.63h-3.13V24h1.43c3.31 0 6-2.69 6-6V6c0-3.31-2.69-6-6-6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebookMono);
export default __webpack_public_path__ + "static/media/social-facebook-mono.e4c416f4f27765801ceac9d3e214d6db.svg";
export { ForwardRef as ReactComponent };